/**
 * Digitain Sportsbook'un hazır renk şemaları ve imza algoritmaları.
 *
 * Kümeler backend'deki `services/sportdigi.py` (`THEMES` / `JWT_ALGORITHMS`)
 * ile **aynı kalmalıdır**: sağlayıcı tanımadığı temayı sessizce varsayılana
 * düşürür ve backend liste dışı değeri 400 ile geri çevirir. Panelde görünüp
 * uygulanamayan bir seçenek "seçtiğim tema kaydedilmiyor" şikâyetinden başka
 * iz bırakmaz.
 *
 * Palet Flexrix ailesinin ortak paletidir (aynı SPA çekirdeği); sağlayıcının
 * kendi panelinde `sportdigiTheme` alanında durur ve anında etkindir —
 * oyuncunun çerçeveyi yenilemesi yeterlidir.
 */
export const SPORTDIGI_THEMES = [
  { value: 'flexrix-red', label: 'Flexrix Red Black (varsayılan)' },
  { value: 'royal-blue', label: 'Royal Blue Dark' },
  { value: 'emerald-dark', label: 'Emerald Dark' },
  { value: 'gold-black', label: 'Gold Black' },
  { value: 'purple-velvet', label: 'Purple Velvet' },
  { value: 'light-blue', label: 'Light Blue' },
  { value: 'light-crimson', label: 'Light Crimson' },
  { value: 'light-black', label: 'Light Black' },
  { value: 'champagne-gold', label: 'Champagne Gold' },
  { value: 'forest-green', label: 'Forest Green' },
  { value: 'electric-lime', label: 'Electric Lime' },
  { value: 'azure-light', label: 'Azure Light' },
  { value: 'carbon-silver', label: 'Carbon Silver' },
  { value: 'synthwave', label: 'Synthwave' },
  { value: 'sunset-orange', label: 'Sunset Orange' },
  { value: 'mint-light', label: 'Mint Light' },
  { value: 'rose-gold', label: 'Rose Gold' },
  { value: 'midnight-cyan', label: 'Midnight Cyan' },
  { value: 'navy-amber', label: 'Navy Amber' },
  { value: 'olive-tactical', label: 'Olive Tactical' },
  { value: 'blood-orange', label: 'Blood Orange' },
  { value: 'amber-graphite', label: 'Amber Graphite' },
];

/**
 * SPA'nın arayüz dili. Küme **kapalıdır** ve backend'deki `LANGUAGES` ile
 * aynı kalmalıdır: sağlayıcı tanımadığı dili sessizce markanın varsayılanına
 * düşürür, yani panelde görünüp uygulanamayan bir seçenek "Türkçe seçtim,
 * kitap İngilizce açılıyor" şikâyetinden başka iz bırakmaz.
 *
 * Dil hem açılış adresine (`?lang=`) hem oturum jetonuna yazılır; sağlayıcının
 * sırası adres → jeton → markanın varsayılanıdır.
 */
export const SPORTDIGI_LANGUAGES = [
  { value: 'tr', label: 'Türkçe' },
  { value: 'en', label: 'İngilizce' },
  { value: 'de', label: 'Almanca' },
  { value: 'fr', label: 'Fransızca' },
  { value: 'es', label: 'İspanyolca' },
  { value: 'it', label: 'İtalyanca' },
  { value: 'pt', label: 'Portekizce' },
  { value: 'ru', label: 'Rusça' },
  { value: 'ar', label: 'Arapça' },
  { value: 'fa', label: 'Farsça' },
];

// HS256 varsayılandır: anahtar zaten `api_secret`'tir ve kurulum tek bir sır
// taşır. RS256 yalnızca sağlayıcıya ayrı bir açık anahtar veren kurulumlar
// içindir ve özel anahtarın panele girilmesini gerektirir.
export const SPORTDIGI_JWT_ALGORITHMS = [
  { value: 'HS256', label: 'HS256 (API secret ile) — önerilen' },
  { value: 'RS256', label: 'RS256 (RSA açık/özel anahtar)' },
];

export default SPORTDIGI_THEMES;
